export default __webpack_public_path__ + "static/media/espa2.1f1bc997.png";